import React from "react"
/* eslint-disable */
interface DownloadProps {
  onClick?: () => {} | void
  className?: string
  width?: string
  height?: string
  stroke?: string
  strokeWidth?: string
}
function EditDropIcon(prop: DownloadProps) {
  const { onClick, className, width, height, stroke, strokeWidth } = prop
  const cssClassName = className || ""
  const cssWidth = width || "1em"
  const cssHeight = height || "1em"
  const cssStroke = stroke || "currentColor"
  const cssStrokeWidth = strokeWidth || "0.5"
  return (
    <span onClick={onClick} className="anticon anticon-add">
      <svg
        className={cssClassName}
        xmlns="http://www.w3.org/2000/svg"
        width={cssWidth}
        height={cssHeight}
        fill="none"
        viewBox="0 0 14 14"
      > 
          <path
            d="M7.7356 2.10118L2.94644 7.17035C2.76561 7.36285 2.59061 7.74202 2.55561 8.00452L2.33977 9.89452C2.26394 10.577 2.75394 11.0437 3.43061 10.927L5.30894 10.6062C5.57144 10.5595 5.93894 10.367 6.11977 10.1687L10.9089 5.09952C11.7373 4.22452 12.1106 3.22702 10.8214 2.00785C9.5381 0.800351 8.56394 1.22618 7.7356 2.10118Z"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.93555 2.94531C7.18638 4.55531 8.49305 5.78615 10.1147 5.94948"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1.75 12.832H12.25"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          /> 
      </svg>
    </span>
  )
}

export default EditDropIcon
